import React, { Component } from 'react';
import '../css/contact.css';

class Contact extends Component {
render(){
return(<div>

<div id="backgroundC">


</div>
</div>);
}
}
export default Contact;